import { firma, kontakt } from '../content';
import './Datenschutz.css';

/**
 * Eigens formulierter Text - content.ts enthaelt keinen Datenschutz-Baustein,
 * das ist hier auch richtig so: Rechtstexte gehoeren nicht in eine
 * wiederverwendbare Marketing-Textquelle. Beschrieben wird ausschliesslich,
 * was diese Website tatsächlich tut - keine Textbausteinsammlung, die hier
 * nicht zutrifft. Der Prüfhinweis ist Pflicht laut Auftrag.
 *
 * ACHTUNG BEI ÄNDERUNGEN AM FORMULAR: Dieser Text stand einmal auf "Kontakt
 * per mailto, es geht nichts an einen Server". Als Home.tsx auf echten Versand
 * umgestellt wurde, blieb er stehen - eine falsche Aussage in einem rechtlich
 * bindenden Dokument, direkt neben der Einwilligungs-Zustimmung. Wer den
 * Formularweg anfasst, ändert diesen Abschnitt mit.
 */
export function Datenschutz() {
  return (
    <div className="legal-page">
      <div className="container legal-page__inner">
        <h1 className="legal-page__title">Datenschutzerklärung</h1>

        <div className="legal-page__notice" role="note">
          Hinweis: Dieser Text ist keine Rechtsberatung und wurde ohne anwaltliche Prüfung erstellt.
          Er ist vor dem Livegang der Website durch eine Rechtsanwältin oder einen Rechtsanwalt zu
          prüfen.
        </div>

        <section className="legal-page__section">
          <h2 className="legal-page__heading">Verantwortlicher</h2>
          <p>
            Verantwortlich für die Datenverarbeitung auf dieser Website ist {firma.name},{' '}
            {firma.inhaber}, {firma.strasse}, {firma.ort}, E-Mail:{' '}
            <a href={`mailto:${firma.mailAllgemein}`}>{firma.mailAllgemein}</a>.
          </p>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__heading">Diese Website im Überblick</h2>
          <p>
            Diese Website bindet keine externen Ressourcen ein: Die verwendeten Schriften Jost und
            Work Sans liegen lokal auf diesem Server statt bei Google Fonts oder einem anderen
            Drittanbieter. Es gibt keine Landkarten, keine Analyse- oder Trackingdienste und keine
            Cookies mit Ausnahme technisch zwingend erforderlicher — davon setzt diese Website
            derzeit keinen einzigen.
          </p>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__heading">Kontaktaufnahme</h2>
          <p>
            Wenn Sie das Kontaktformular auf der Startseite absenden, werden die von Ihnen
            eingegebenen Angaben — Name, E-Mail-Adresse und Nachrichtentext — an einen Dienst
            auf diesem Server übermittelt und von dort per E-Mail an{' '}
            {firma.mailAllgemein} weitergeleitet. Ihre E-Mail-Adresse wird dabei als
            Antwortadresse gesetzt, damit wir Ihnen antworten können.
          </p>
          <p>
            <strong>Es wird nichts gespeichert.</strong> Der Dienst führt keine Datenbank und
            legt keine Kopie Ihrer Nachricht an; sie liegt anschließend ausschließlich in
            unserem E-Mail-Postfach. Zum Schutz vor massenhaftem Versand merkt sich der Dienst
            für eine Stunde, von welcher IP-Adresse wie viele Nachrichten kamen. Diese Angabe
            liegt nur im Arbeitsspeicher, wird nicht auf die Festplatte geschrieben und ist
            nach Ablauf der Stunde verschwunden.
          </p>
          <p>
            Die Verarbeitung erfolgt zur Bearbeitung Ihrer Anfrage auf Grundlage von Art. 6
            Abs. 1 lit. b DSGVO (vorvertragliche Maßnahmen) beziehungsweise Art. 6 Abs. 1
            lit. f DSGVO (berechtigtes Interesse an der Beantwortung von Anfragen sowie am
            Schutz vor missbräuchlicher Nutzung des Formulars). Ihre Nachricht bewahren wir so
            lange auf, wie es zur Bearbeitung nötig ist, und darüber hinaus, soweit
            gesetzliche Aufbewahrungsfristen dies verlangen.
          </p>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__heading">Technischer Betrieb (Server-Logfiles)</h2>
          <p>
            Beim Aufruf dieser Website verarbeitet der Webserver aus technischen Gründen
            automatisch Verbindungsdaten (zum Beispiel IP-Adresse, Datum und Uhrzeit des Zugriffs,
            aufgerufene Seite, verwendeter Browser), um die Website stabil und sicher
            auszuliefern. Dies geschieht auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO (berechtigtes
            Interesse am sicheren Betrieb). Eine darüberhinausgehende Auswertung, Profilbildung
            oder Weitergabe findet nicht statt.
          </p>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__heading">Ihre Rechte</h2>
          <p>
            Sie haben nach der Datenschutz-Grundverordnung das Recht auf Auskunft (Art. 15 DSGVO),
            Berichtigung (Art. 16 DSGVO), Löschung (Art. 17 DSGVO), Einschränkung der Verarbeitung
            (Art. 18 DSGVO), Datenübertragbarkeit (Art. 20 DSGVO) sowie Widerspruch gegen die
            Verarbeitung (Art. 21 DSGVO). Wenden Sie sich dazu formlos an die oben genannte
            Kontaktadresse.
          </p>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__heading">Beschwerderecht</h2>
          <p>
            Sie haben zudem das Recht, sich bei einer Datenschutz-Aufsichtsbehörde zu beschweren,
            insbesondere bei der für den Sitz des Unternehmens zuständigen Landesbeauftragten für
            den Datenschutz Niedersachsen (LfD Niedersachsen).
          </p>
        </section>
      </div>
    </div>
  );
}
